export const sizeClass = {
  xs: "h-7 px-2.5 py-0.5 gap-2 text-xs",
  sm: "h-8 px-3 py-1 gap-2.5 text-sm",
  lg: "h-10 px-4 py-2 gap-4 text-lg font-bold",
  xl: "h-12 text-xl gap-4 px-5 py-2.5 font-bold",
  base: "h-9 px-4 py-2 gap-4 text-base font-medium",
};
export const categoryClass = {
  primary:
    "bg-app-400 hover:bg-app-600 text-black dark:text-white focus-visible:outline-app-500",
  secondary:
    "dark:bg-white/10 bg-black/10 hover:bg-white/20 text-black dark:text-white",
  save: " border-green-400 bg-green-400 hover:bg-green-600 text-white focus-visible:outline-green-600 !shadow-[inset_1px_1px_4px_1px_#14422A,_inset_-1px_-1px_4px_1px_#A1DFBE77]",
  reject:
    " border-red-400 bg-red-400 hover:bg-red-600 text-gray-100 focus-visible:outline-red-400  !shadow-[inset_1px_1px_4px_1px_#481312,_inset_-1px_-1px_4px_1px_#E69F9E77]",
  blank: "bg-transparent hover:dark:bg-white/10 text-black dark:text-white",
};
